import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const getAllTemplateApi = createAsyncThunk(
  "getAllTemplate",
  async () => {
    const response = await axiosInstance.get(`/getAllTemplate`);
    return response.data;
  }
);

const getAllTemplateSlice = createSlice({
  name: "getAllTemplate",
  initialState: {
    getAllTemplate: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTemplateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTemplateApi.fulfilled, (state, action) => {
        state.getAllTemplate = action.payload;
        state.loading = false;
      })
      .addCase(getAllTemplateApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default getAllTemplateSlice.reducer;
